import { StarknetWindowObject, connect, disconnect } from "get-starknet";
import { Wallet } from './Wallet';
export class StarkNetWallet extends Wallet {
    context: StarknetWindowObject | null = null;
    constructor() {
        super();
    }

    async connect(): Promise<string> {
        this.context = await connect();
        console.log("StarkNet context:");
        console.log(this.context);
        if(this.context?.isConnected){
            const addr = this.context.selectedAddress || "";
            if(addr.length === 63) this.account = `0x0${addr.substring(2)}`;
            else this.account = addr;
            this.originalAccount = this.account;
            this.walletProvider = this.context.id;

            // console.log(`Starknet account:`);
            // console.log(this.context?.account);

            // throws error
            // this.publicKey = await this.context.account.signer.getPubKey();
            // console.log(`Starknet PubKey: ${this.publicKey}`);
        }

        console.log(`Starknet address: ${this.account}`);
        return this.account;
    }

    async signMessage(message: string): Promise<string> {
        let signature = "";
        //(this.provider as EthProvider).sign()
        return signature;
    }

    async verifyMessage(): Promise<boolean> {
        return false;
    }
}
// braavos: length=63 x >> 64, 32 bytes
// 0x06f60ffc4f0bac7030721d513ee9345de032bf4614d444fd10e4a35986b7ed59   // braavos
// argentx: length = 64, 32 bytes
// 0x071988909ab87B949F183030F3BF3C2FB7903e81Fee549fFF6B98797d3F9dB8a  // argent-x
